// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1Q7UE","content":"LoadingAlert_content__1Yjrq"};